/* eslint-disable @typescript-eslint/no-non-null-assertion */
import { z } from 'zod';

// Don't use `z.coerce()`, because safePare
// is only used to validate environment variables!
const envSchema = z.object({
  NEXT_PUBLIC_ENVIRONMENT: z.string().optional(),
  DEBUG: z.string().optional(),
  NODE_ENV: z.enum(['development', 'production', 'test']),
  NEXT_PUBLIC_API_URL: z.string().min(1),
  AUTH_URL: z.string().min(1),
  AUTH_SECRET: z.string().min(1),
  AUTH_MICROSOFT_ENTRA_ID: z.string().min(1),
  AUTH_MICROSOFT_ENTRA_ID_SECRET: z.string().min(1),
  AUTH_MICROSOFT_ENTRA_ID_ISSUER: z.string().min(1),
});

const ENV: z.infer<typeof envSchema> = {
  NEXT_PUBLIC_ENVIRONMENT: process.env.NEXT_PUBLIC_ENVIRONMENT,
  NODE_ENV: process.env.NODE_ENV,
  DEBUG: process.env.NEXT_PUBLIC_DEBUG,
  NEXT_PUBLIC_API_URL: process.env.NEXT_PUBLIC_API_URL!,
  AUTH_URL: process.env.AUTH_URL!,
  AUTH_SECRET: process.env.AUTH_SECRET!,
  AUTH_MICROSOFT_ENTRA_ID: process.env.AUTH_MICROSOFT_ENTRA_ID_ID!,
  AUTH_MICROSOFT_ENTRA_ID_SECRET: process.env.AUTH_MICROSOFT_ENTRA_ID_SECRET!,
  AUTH_MICROSOFT_ENTRA_ID_ISSUER: process.env.AUTH_MICROSOFT_ENTRA_ID_ISSUER!,
};

// Due to the fact that the environment variables (without NEXT_PUBLIC) are not available in the browser,
// we need to check if we are in a server environment - during building the app
// eslint-disable-next-line @typescript-eslint/no-unnecessary-condition
if (globalThis.window === undefined) {
  const envs = envSchema.safeParse(ENV);
  if (!envs.success) {
    // eslint-disable-next-line no-console
    console.error(envs.error);
    throw new Error('env.ts: Invalid environment variables!');
  }
}

export { ENV };
